module.exports = __webpack_public_path__ + "static/media/big-egg.83d818ec.svg";